'use client';

type Props = {
  label: string;
  countReviews: number;
};

export default function ScrollableRatingDescription({
  countReviews,
  label,
}: Props) {
  function handleScrollToReviewSection() {
    const reviewSection = document.getElementById('reviews-ref');
    if (reviewSection) {
      reviewSection.scrollIntoView({behavior: 'smooth'});
    }
  }
  return (
    <span
      onClick={handleScrollToReviewSection}
      className="text-gray-700 cursor-pointer">
      {countReviews} {label}
    </span>
  );
}
